module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedBlack.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedBlack.ttf
// module id = 999
// module chunks = 19